<!-- /components/modal/Header.vue -->
<template>
  <div class="modal-header">
    {{ headerTitle }}
    <div class="modal-nav">
      <a class="modal-close" href="javascript:" @click="closeModal"></a>
      <!--<a class="modal-help" target="_blank" href="https://www.youtube.com"></a>-->
    </div>
  </div>
</template>

<script setup>
import { useUIStore } from '@/store/uiStore';
import { ModalTypes } from '@/types/enums';

const props = defineProps({
  headerTitle: String
});

const uiStore = useUIStore();

const closeModal = () => {
  uiStore.setModalType(ModalTypes.INACTIVE);
};
</script>

<style lang="scss" scoped>
@import '~/assets/constants.scss';

.modal-header {
  background: $fa-orange;
  color: $light-white;
  font-weight: bold;
  padding: 0.25rem 2rem;
  border-radius: $fa-border-radius $fa-border-radius 0 0;
  display: grid;
  grid-template-columns: 3.75fr 1fr;
  align-items: center;

  .dark-mode & {
    background: none;
    border-bottom: 1px solid $fa-orange;
  }
}

.modal-help,
.modal-close {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.5rem;
  float: right;
  margin-left: 1rem;

  &:hover {
    color: rgba(255, 255, 255, 1.0);
  }

  &:before {
    font-family: 'FontAwesome';
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    position: relative;
    -webkit-font-smoothing: antialiased;
  }
}

.modal-help:before {
  content: "\f059";
}

.modal-close:before {
  content: "\f057";
}

</style>

